import React from "react";
import Wallets from "../../Components/Wallets";

const MainWallet = () => {
	return <Wallets />;
};

export default MainWallet;
